export const OPTIMIZED_DATE = new Date(2024, 10, 22);

export const AI_BIO_PROMPT_NAME = 'profile_content_v1';

export const BIO_SURVEY_LINK = 'https://t.maze.co/292656643';

export interface IEnhancedBio {
  id: string;
  sourceText: string;
  enhancedText: string;
  active: boolean;
  personaProviderId: number;
  providerAccepted: boolean | null;
  promptName: string;
}
